/**
 * הסרת/טשטוש מזהי ספק ומחרוזות LDS מתוך טקסט שיופיע בהצעת מחיר (PDF / לינק ציבורי).
 * לא משנה את מקור הנתונים בחיפוש — רק העתקה לקוחית.
 */

const DEFAULT_REPLACEMENTS = ["הספק המקומי", "מארגן הטיול"];

function escapeRegex(s) {
  return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/** @typedef {{ supplierName?: string|null, supplierCode?: string|null, supplierId?: string|null }} SupplierMetaLike */

function buildSupplierTokens(supplierMeta) {
  const m =
    supplierMeta && typeof supplierMeta === "object" ? supplierMeta : {};
  const tokens = [];
  const push = (v) => {
    const s =
      v != null && String(v).trim()
        ? String(v).trim()
        : null;
    if (s && s.length >= 2) tokens.push(s);
  };
  push(m.supplierName);
  push(m.supplierCode);
  push(m.supplierId);
  return [...new Set(tokens)];
}

function replaceAllCaseInsensitive(text, needle, replacement) {
  let out = text;
  const n = escapeRegex(String(needle));
  if (!n) return out;
  const re = new RegExp(n, "gi");
  out = out.replace(re, replacement);
  return out;
}

/**
 * @param {string|null|undefined} text
 * @param {SupplierMetaLike} [supplierMeta]
 * @returns {string}
 */
export function sanitizeOrganizedTourQuoteText(text, supplierMeta) {
  let out = text == null ? "" : String(text);
  const beforeSnippet = out.length > 200 ? `${out.slice(0, 200)}…` : out;

  const supplierTokens = buildSupplierTokens(supplierMeta);
  /** @type {Array<[string,string]>} */
  const fixedPairs = [
    ["אשת טורס", DEFAULT_REPLACEMENTS[0]],
    ["###SUPPLIER_PREPARED###", ""],
  ];
  fixedPairs.forEach(([a, b]) => {
    out = replaceAllCaseInsensitive(out, a, b);
  });
  out = replaceAllCaseInsensitive(out, "Eshet", DEFAULT_REPLACEMENTS[1]);
  out = replaceAllCaseInsensitive(out, "ESHET", DEFAULT_REPLACEMENTS[1]);

  supplierTokens.forEach((tok) => {
    out = replaceAllCaseInsensitive(out, tok, DEFAULT_REPLACEMENTS[0]);
  });

  const noiseRe =
    /\b(LDS\s*\d+[A-Za-z0-9\-_]*|[A-Za-z]{2,12}\/\d+[A-Za-z0-9\-_/]*|\blds[_-]?supplier\b|\bsuppliercode\b\s*[:=]\s*[\w-]+\b|\bsupplierid\b\s*[:=]\s*[\w-]+\b|\bsupplier[_-]?code\b\s*[:=]\s*[\w-]+\b)/gi;
  out = out.replace(noiseRe, "");

  while (/\s{3,}/g.test(out)) {
    out = out.replace(/\s{3,}/g, "  ");
  }
  out = out.replace(/\(\s*\)/g, "").replace(/\[\s*\]/g, "").trim();

  if (typeof console !== "undefined" && console.info) {
    console.info("[ORG_TOUR_QUOTE_TEXT_SANITIZE_TRACE]", "[ORG_TOUR_QUOTE_SUPPLIER_SANITIZE_TRACE]", {
      beforeSnippet,
      supplierTokensTruncated: supplierTokens.slice(0, 12),
      afterLength: out.length,
      changed: beforeSnippet.slice(0, 120) !== out.slice(0, 120),
    });
    console.info("[ORG_TOUR_QUOTE_REUSE_EXISTING_FLOW_TRACE]", "[ORG_TOUR_QUOTE_DATA_ADAPTER_TRACE]", {
      adapter: "sanitizeOrganizedTourQuoteText",
      productType: "organized_tour",
    });
  }

  return out;
}
